export default {
  deleteVisit: 'Delete Visit',
  deleteVisitErrorMsg: 'Unable to delete visit.  Please refresh SmartChart and try again.',
  deleteVisitConfMsgTitle: 'Delete Visit Confirmation',
  deleteVisitConfMsg: 'WARNING: This action will delete the visit. Are you sure you wish to proceed?',
  canNotdeleteVisitConfMsg: "This visit has documentation attached and can't be deleted",
  ok: 'OK',
  cancel: 'Cancel'
};